module.exports = __webpack_public_path__ + "img/snapchat.c1d30d5e.svg";